import httpClient from "./httpClient";

class channelService {
    async getChannel() {
        return httpClient("/portals/travel/channels");
    }
}

export default new channelService();